module.exports = __webpack_public_path__ + "making-memories.jpg?542520444c2bc1793506c5d2470d8907";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/making-memories.jpg
// module id = 117
// module chunks = 0